import { ExtendProps } from 'app';
import { ReactNode } from 'react';

type SocialActionCardProps = {
	context: string;
	title: string;
	description: ReactNode;
	Link?: ReactNode;
} & React.ComponentProps<'div'>;
export const SocialActionCard = ({
	context,
	description,
	title,
	Link,
	className,
}: ExtendProps<SocialActionCardProps>) => {
	return (
		<div
			className={`relative min-h-max h-[416px] w-[100%] max-w-[256px] flex flex-col items-start shadow-md rounded-xl ${className}`}
		>
			<div className="relative w-full text-center [border-top-left-radius:8px] [border-top-right-radius:8px] py-1 text-black border-b-2 border-b-primary-dark">
				<strong className="text-sm text-primary-dark">{context}</strong>
			</div>
			<div className="p-4 rounded-b-2xl rounded-br-2xl text-center flex-1 text-black">
				<strong className="block mb-4 h-10 ">{title}</strong>
				<p className="text-left">{description}</p>
			</div>

			{Link}
		</div>
	);
};
